import { jsx, jsxs } from "react/jsx-runtime";
import { c } from "react-compiler-runtime";
import "react";
const NeutralEmoji = ()=>{
    const $ = c(20);
    let t0;
    let t1;
    let t2;
    let t3;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ jsx("path", {
            d: "M15.9973 27.2493C22.2089 27.2493 27.2445 22.2194 27.2445 16.0148C27.2445 9.81013 22.2089 4.78027 15.9973 4.78027C9.78557 4.78027 4.75 9.81013 4.75 16.0148C4.75 22.2194 9.78557 27.2493 15.9973 27.2493Z",
            fill: "url(#paint0_radial_10778_952)"
        });
        t1 = /*#__PURE__*/ jsx("path", {
            d: "M15.9973 27.2493C22.2089 27.2493 27.2445 22.2194 27.2445 16.0148C27.2445 9.81013 22.2089 4.78027 15.9973 4.78027C9.78557 4.78027 4.75 9.81013 4.75 16.0148C4.75 22.2194 9.78557 27.2493 15.9973 27.2493Z",
            fill: "url(#paint1_radial_10778_952)"
        });
        t2 = /*#__PURE__*/ jsx("path", {
            d: "M16.0012 27.2183C22.2128 27.2183 27.2484 22.1884 27.2484 15.9838C27.2484 9.77913 22.2128 4.74927 16.0012 4.74927C9.78947 4.74927 4.75391 9.77913 4.75391 15.9838C4.75391 22.1884 9.78947 27.2183 16.0012 27.2183Z",
            fill: "url(#paint2_radial_10778_952)",
            fillOpacity: "0.8"
        });
        t3 = /*#__PURE__*/ jsx("path", {
            d: "M16.0027 4.74926C9.79106 4.74926 4.75549 9.77911 4.75549 15.9838C4.75549 22.1884 9.79106 27.2183 16.0027 27.2183C22.2144 27.2183 27.25 22.1884 27.25 15.9838C27.25 9.77911 22.2144 4.74926 16.0027 4.74926Z",
            fill: "url(#paint3_radial_10778_952)",
            fillOpacity: "0.8"
        });
        $[0] = t0;
        $[1] = t1;
        $[2] = t2;
        $[3] = t3;
    } else {
        t0 = $[0];
        t1 = $[1];
        t2 = $[2];
        t3 = $[3];
    }
    let t10;
    let t4;
    let t5;
    let t6;
    let t7;
    let t8;
    let t9;
    if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
        t4 = /*#__PURE__*/ jsx("g", {
            opacity: "0.4",
            filter: "url(#filter0_f_10778_952)",
            children: /*#__PURE__*/ jsx("path", {
                d: "M21.7783 8.44515C21.7783 10.058 19.2134 11.3655 16.0493 11.3655C12.8853 11.3655 10.3203 10.058 10.3203 8.44515C10.3203 6.83227 12.8853 5.52478 16.0493 5.52478C19.2134 5.52478 21.7783 6.83227 21.7783 8.44515Z",
                fill: "url(#paint4_radial_10778_952)"
            })
        });
        t5 = /*#__PURE__*/ jsx("path", {
            d: "M20.2859 20.1231C20.9666 20.0653 21.3746 19.7452 21.2868 19.3311C21.1772 18.8144 20.5584 18.8481 20.1525 18.8701L20.1365 18.871C20.1365 18.871 18.6947 18.93 15.9989 18.93C13.3032 18.93 11.8614 18.871 11.8614 18.871C11.456 18.849 10.8221 18.8076 10.711 19.3311C10.6232 19.7452 11.0313 20.0653 11.712 20.1231C11.712 20.1231 13.2874 20.2274 15.9989 20.2274C18.7105 20.2274 20.2859 20.1231 20.2859 20.1231Z",
            fill: "#421D30"
        });
        t6 = /*#__PURE__*/ jsx("path", {
            d: "M18.1583 14.0928C18.1583 15.1724 18.7481 16.0475 19.4756 16.0475C20.2032 16.0475 20.793 15.1724 20.793 14.0928C20.793 13.0132 20.2032 12.1381 19.4756 12.1381C18.7481 12.1381 18.1583 13.0132 18.1583 14.0928Z",
            fill: "#421D30"
        });
        t7 = /*#__PURE__*/ jsx("path", {
            d: "M11.1505 14.0928C11.1505 15.1724 11.7403 16.0475 12.4678 16.0475C13.1954 16.0475 13.7852 15.1724 13.7852 14.0928C13.7852 13.0132 13.1954 12.1381 12.4678 12.1381C11.7403 12.1381 11.1505 13.0132 11.1505 14.0928Z",
            fill: "#421D30"
        });
        t8 = /*#__PURE__*/ jsx("path", {
            d: "M20.1426 18.6831C20.3394 18.6724 20.6242 18.6552 20.875 18.7163C21.0032 18.7476 21.1341 18.8015 21.2432 18.896C21.355 18.9929 21.4351 19.1249 21.4707 19.2925C21.5317 19.5809 21.4124 19.8331 21.1904 20.0083C20.9758 20.1775 20.6638 20.2793 20.3018 20.3101H20.293C20.2898 20.3103 20.2853 20.3107 20.2793 20.311C20.2669 20.3118 20.248 20.3135 20.2236 20.3149C20.1748 20.3178 20.1021 20.3218 20.0068 20.3267C19.8158 20.3365 19.5333 20.3497 19.166 20.3628C18.4312 20.3889 17.3571 20.4145 15.999 20.4146C14.6409 20.4146 13.5669 20.3889 12.832 20.3628C12.4648 20.3497 12.1822 20.3365 11.9912 20.3267C11.896 20.3218 11.8232 20.3178 11.7744 20.3149C11.7501 20.3135 11.7312 20.3118 11.7188 20.311C11.7125 20.3106 11.7073 20.3103 11.7041 20.3101H11.6963C11.3343 20.2793 11.0223 20.1775 10.8076 20.0083C10.5857 19.8331 10.4663 19.5809 10.5273 19.2925C10.5634 19.1228 10.645 18.9902 10.7588 18.8931C10.8698 18.7984 11.0029 18.7449 11.1328 18.7144C11.3869 18.6547 11.6756 18.6735 11.8711 18.6841H11.8857C11.8968 18.6845 11.9135 18.6852 11.9355 18.686C11.9799 18.6876 12.0465 18.6901 12.1348 18.6929C12.3114 18.6984 12.575 18.706 12.9229 18.7134C13.619 18.7281 14.6525 18.7427 15.999 18.7427C17.3452 18.7427 18.3781 18.7281 19.0742 18.7134C19.4223 18.706 19.6866 18.6984 19.8633 18.6929C19.9516 18.6901 20.0181 18.6876 20.0625 18.686C20.0846 18.6852 20.1012 18.6845 20.1123 18.6841H20.126L20.1426 18.6831Z",
            stroke: "url(#paint5_linear_10778_952)",
            strokeWidth: "0.375"
        });
        t9 = /*#__PURE__*/ jsx("path", {
            d: "M19.4756 11.9506C19.0306 11.9506 18.6498 12.2183 18.3887 12.6058C18.1268 12.9945 17.9707 13.5211 17.9707 14.0931C17.9708 14.665 18.1269 15.1909 18.3887 15.5795C18.6498 15.967 19.0306 16.2347 19.4756 16.2347C19.9206 16.2347 20.3013 15.967 20.5625 15.5795C20.8243 15.1909 20.9804 14.665 20.9805 14.0931C20.9805 13.5211 20.8244 12.9945 20.5625 12.6058C20.3013 12.2183 19.9206 11.9506 19.4756 11.9506Z",
            stroke: "url(#paint6_linear_10778_952)",
            strokeWidth: "0.375"
        });
        t10 = /*#__PURE__*/ jsx("path", {
            d: "M12.4678 11.9506C12.0228 11.9506 11.642 12.2183 11.3809 12.6058C11.1189 12.9945 10.9629 13.5211 10.9629 14.0931C10.963 14.665 11.1191 15.1909 11.3809 15.5795C11.642 15.967 12.0228 16.2347 12.4678 16.2347C12.9128 16.2347 13.2935 15.967 13.5547 15.5795C13.8165 15.1909 13.9726 14.665 13.9727 14.0931C13.9727 13.5211 13.8166 12.9945 13.5547 12.6058C13.2935 12.2183 12.9128 11.9506 12.4678 11.9506Z",
            stroke: "url(#paint7_linear_10778_952)",
            strokeWidth: "0.375"
        });
        $[4] = t10;
        $[5] = t4;
        $[6] = t5;
        $[7] = t6;
        $[8] = t7;
        $[9] = t8;
        $[10] = t9;
    } else {
        t10 = $[4];
        t4 = $[5];
        t5 = $[6];
        t6 = $[7];
        t7 = $[8];
        t8 = $[9];
        t9 = $[10];
    }
    let t11;
    if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
        t11 = /*#__PURE__*/ jsxs("filter", {
            id: "filter0_f_10778_952",
            x: "7.48829",
            y: "2.69276",
            width: "17.1211",
            height: "11.5048",
            filterUnits: "userSpaceOnUse",
            colorInterpolationFilters: "sRGB",
            children: [
                /*#__PURE__*/ jsx("feFlood", {
                    floodOpacity: "0",
                    result: "BackgroundImageFix"
                }),
                /*#__PURE__*/ jsx("feBlend", {
                    mode: "normal",
                    in: "SourceGraphic",
                    in2: "BackgroundImageFix",
                    result: "shape"
                }),
                /*#__PURE__*/ jsx("feGaussianBlur", {
                    stdDeviation: "1.41601",
                    result: "effect1_foregroundBlur_10778_952"
                })
            ]
        });
        $[11] = t11;
    } else t11 = $[11];
    let t12;
    if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
        t12 = /*#__PURE__*/ jsxs("radialGradient", {
            id: "paint0_radial_10778_952",
            cx: "0",
            cy: "0",
            r: "1",
            gradientUnits: "userSpaceOnUse",
            gradientTransform: "translate(15.6674 6.1244) scale(21.0254 21.0015)",
            children: [
                /*#__PURE__*/ jsx("stop", {
                    stopColor: "#FFF1B6"
                }),
                /*#__PURE__*/ jsx("stop", {
                    offset: "0.43",
                    stopColor: "#FFD400"
                }),
                /*#__PURE__*/ jsx("stop", {
                    offset: "0.7",
                    stopColor: "#FFD400"
                }),
                /*#__PURE__*/ jsx("stop", {
                    offset: "1",
                    stopColor: "#FF8E00"
                })
            ]
        });
        $[12] = t12;
    } else t12 = $[12];
    let t13;
    if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
        t13 = /*#__PURE__*/ jsxs("radialGradient", {
            id: "paint1_radial_10778_952",
            cx: "0",
            cy: "0",
            r: "1",
            gradientTransform: "matrix(12.8888 18.1855 -18.2053 12.8311 10.9042 6.54712)",
            gradientUnits: "userSpaceOnUse",
            children: [
                /*#__PURE__*/ jsx("stop", {
                    offset: "0.608798",
                    stopColor: "#FFE437",
                    stopOpacity: "0"
                }),
                /*#__PURE__*/ jsx("stop", {
                    offset: "0.858784",
                    stopColor: "#FF79B1",
                    stopOpacity: "0.45"
                }),
                /*#__PURE__*/ jsx("stop", {
                    offset: "0.994222",
                    stopColor: "#FF3673",
                    stopOpacity: "0.56"
                })
            ]
        });
        $[13] = t13;
    } else t13 = $[13];
    let t14;
    if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
        t14 = /*#__PURE__*/ jsxs("radialGradient", {
            id: "paint2_radial_10778_952",
            cx: "0",
            cy: "0",
            r: "1",
            gradientUnits: "userSpaceOnUse",
            gradientTransform: "translate(16.0012 16.4953) rotate(-90) scale(12.3591 11.8207)",
            children: [
                /*#__PURE__*/ jsx("stop", {
                    offset: "0.848958",
                    stopColor: "#FFC60C",
                    stopOpacity: "0"
                }),
                /*#__PURE__*/ jsx("stop", {
                    offset: "1",
                    stopColor: "#FF7039",
                    stopOpacity: "0.68"
                })
            ]
        });
        $[14] = t14;
    } else t14 = $[14];
    let t15;
    if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
        t15 = /*#__PURE__*/ jsxs("radialGradient", {
            id: "paint3_radial_10778_952",
            cx: "0",
            cy: "0",
            r: "1",
            gradientUnits: "userSpaceOnUse",
            gradientTransform: "translate(16.0027 15.4722) rotate(90) scale(11.7461 11.6609)",
            children: [
                /*#__PURE__*/ jsx("stop", {
                    offset: "0.847356",
                    stopColor: "#FE789B",
                    stopOpacity: "0"
                }),
                /*#__PURE__*/ jsx("stop", {
                    offset: "1",
                    stopColor: "#F11414",
                    stopOpacity: "0.41"
                })
            ]
        });
        $[15] = t15;
    } else t15 = $[15];
    let t16;
    if ($[16] === Symbol.for("react.memo_cache_sentinel")) {
        t16 = /*#__PURE__*/ jsxs("radialGradient", {
            id: "paint4_radial_10778_952",
            cx: "0",
            cy: "0",
            r: "1",
            gradientUnits: "userSpaceOnUse",
            gradientTransform: "translate(16.0493 8.44515) rotate(89.9999) scale(2.92037 5.37497)",
            children: [
                /*#__PURE__*/ jsx("stop", {
                    stopColor: "white"
                }),
                /*#__PURE__*/ jsx("stop", {
                    offset: "1",
                    stopColor: "#FFED49",
                    stopOpacity: "0"
                })
            ]
        });
        $[16] = t16;
    } else t16 = $[16];
    let t17;
    if ($[17] === Symbol.for("react.memo_cache_sentinel")) {
        t17 = /*#__PURE__*/ jsxs("linearGradient", {
            id: "paint5_linear_10778_952",
            x1: "15.9989",
            y1: "18.7873",
            x2: "15.9989",
            y2: "20.3923",
            gradientUnits: "userSpaceOnUse",
            children: [
                /*#__PURE__*/ jsx("stop", {
                    offset: "0.311321",
                    stopColor: "#FD9E28",
                    stopOpacity: "0.8"
                }),
                /*#__PURE__*/ jsx("stop", {
                    offset: "1",
                    stopColor: "#FFE9AD"
                })
            ]
        });
        $[17] = t17;
    } else t17 = $[17];
    let t18;
    if ($[18] === Symbol.for("react.memo_cache_sentinel")) {
        t18 = /*#__PURE__*/ jsxs("linearGradient", {
            id: "paint6_linear_10778_952",
            x1: "19.4756",
            y1: "12.1381",
            x2: "19.4756",
            y2: "16.0475",
            gradientUnits: "userSpaceOnUse",
            children: [
                /*#__PURE__*/ jsx("stop", {
                    stopColor: "#FF9614"
                }),
                /*#__PURE__*/ jsx("stop", {
                    offset: "1",
                    stopColor: "#FFE6A6"
                })
            ]
        });
        $[18] = t18;
    } else t18 = $[18];
    let t19;
    if ($[19] === Symbol.for("react.memo_cache_sentinel")) {
        t19 = /*#__PURE__*/ jsxs("svg", {
            width: "32",
            height: "32",
            viewBox: "0 0 32 32",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            children: [
                t0,
                t1,
                t2,
                t3,
                t4,
                t5,
                t6,
                t7,
                t8,
                t9,
                t10,
                /*#__PURE__*/ jsxs("defs", {
                    children: [
                        t11,
                        t12,
                        t13,
                        t14,
                        t15,
                        t16,
                        t17,
                        t18,
                        /*#__PURE__*/ jsxs("linearGradient", {
                            id: "paint7_linear_10778_952",
                            x1: "12.4678",
                            y1: "12.1381",
                            x2: "12.4678",
                            y2: "16.0475",
                            gradientUnits: "userSpaceOnUse",
                            children: [
                                /*#__PURE__*/ jsx("stop", {
                                    stopColor: "#FF9614"
                                }),
                                /*#__PURE__*/ jsx("stop", {
                                    offset: "1",
                                    stopColor: "#FFE6A6"
                                })
                            ]
                        })
                    ]
                })
            ]
        });
        $[19] = t19;
    } else t19 = $[19];
    return t19;
};
export { NeutralEmoji };
